// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessagingAnalytics_ChartDataResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/messaging_analytics/chart_data/{type}
 *
 * Returns the per-device daily message-volume breakdown for the period
 * defined by the active filter. The `type` path segment (default `'volume'`)
 * is echoed back as `tipo`.
 *
 * Shape mirrors `Messaging_analytics::chart_data()`:
 *
 *   array(
 *     'periodo'         => array('inicio' => 'Y-m-d', 'fim' => 'Y-m-d'),
 *     'tipo'            => string,
 *     'por_dispositivo' => array<int, array{
 *         device_name: string,
 *         provider_type: string,
 *         dados_diarios: array<int, array{
 *             data: string,
 *             mensagens_enviadas: int,
 *             mensagens_recebidas: int,
 *         }>,
 *     }>,
 *   )
 */
import type { MessagingAnalytics_ChartDataDispositivoRow } from './MessagingAnalytics_ChartDataDispositivoRow'
import type { MessagingAnalytics_ChartDataPeriodoRow } from './MessagingAnalytics_ChartDataPeriodoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MessagingAnalytics_ChartDataResponseDados {
por_dispositivo: MessagingAnalytics_ChartDataDispositivoRow[]
periodo?: MessagingAnalytics_ChartDataPeriodoRow
tipo?: string
}

export type MessagingAnalytics_ChartDataResponse = ApiResponse<MessagingAnalytics_ChartDataResponseDados>;

registerResponseContract('MessagingAnalytics_ChartDataResponse', {
  por_dispositivo: {
    type: 'array',
    required: true,
    items: {
      device_name:   { type: 'string',  required: true },
      provider_type: { type: 'string',  required: true },
      dados_diarios: {
        type: 'array',
        required: false,
        items: {
          data:                { type: 'string',  required: true },
          mensagens_enviadas:  { type: 'number',  required: true },
          mensagens_recebidas: { type: 'number',  required: true },
        },
      },
    },
  },
  periodo: {
    type: 'object',
    required: false,
    fields: {
      inicio: { type: 'string',  required: true },
      fim:    { type: 'string',  required: true },
    },
  },
  tipo:            { type: 'string',  required: false },
})
